import Vue from 'vue'

export default {
  getDetails (locationName, periodId) {
    return Vue.http.get('/location/details', {
      params: {
        location_name: locationName,
        period_id: periodId
      }
    })
  }
}
